import { connect } from 'react-redux';

import { schedulePurchaseOrderToActiveCrew } from '../../../redux/calendar';
import { updateSearchCriteria } from '../../../redux/searchPurchaseOrders';
import AvailablePurchaseOrders from './AvailablePurchaseOrders';

const mapStateToProps = (state) => ({
  ...state.searchPurchaseOrders,
  activeCrew: state.calendar.activeCrew,
  dropdowns: state.dropdowns,
  locationEnabled: state.settings.locationEnabled,
  purchaseOrders: state.searchPurchaseOrders.purchaseOrders
});

const mapDispatchToProps = {
  onPurchaseOrderClick: schedulePurchaseOrderToActiveCrew,
  onFormUpdate: updateSearchCriteria
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailablePurchaseOrders);
